import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';

import './NoteFieldLayout.scss';

export interface NoteFieldLayoutProps {
    placeholder?: string;
    label?: string;
    note?: string;
    error?: string;
    icon?: IconTypes | ReturnType<typeof Icon>;
    labelAlwaysOn?: boolean;
    isNettbank?: boolean;
}

const NoteFieldLayout: React.FC<NoteFieldLayoutProps> = ({
    label,
    note,
    placeholder = '',
    error,
    icon,
    labelAlwaysOn = false,
    isNettbank = false,
}) => {
    const renderContent = () => {
        if (error && isNettbank) {
            return (
                <div className="note-field-container">
                    <div className="note-field-layout__label">{label}</div>
                    <div className="note-field-layout__note">{note}</div>
                    <span className="note-field-layout__left-single-value" role="alert">
                        <ErrorLabel className="note-field-layout__error-label" text={error} />
                    </span>
                </div>
            );
        }

        if (error) {
            return (
                <div className="note-field-container">
                    <span className="note-field-layout__left-single-value" role="alert">
                        <ErrorLabel
                            className="note-field-layout__error-label"
                            data-testid="message-field-error-message"
                            text={error}
                        />
                    </span>
                </div>
            );
        }
        if (note) {
            return (
                <div className="note-field-container">
                    <div className="note-field-layout__label">{label}</div>
                    <div className="note-field-layout__note" data-testid="message-note-field">
                        {note}
                    </div>
                </div>
            );
        }

        if (!note && labelAlwaysOn) {
            return (
                <div className="note-field-container">
                    <div className="note-field-layout__label">{label}</div>
                    <div className="note-field-layout__placeholder">{placeholder}</div>
                </div>
            );
        }
        return (
            <div className="note-field-container">
                <div className="note-field-layout__placeholder" data-testid="note-field-empty-message">
                    {placeholder}
                </div>
            </div>
        );
    };

    const renderIcon = () => {
        if (React.isValidElement(icon)) return icon;
        return <Icon type={icon as IconTypes} className="icon--20" />;
    };

    return (
        <div className="note-field-layout__container">
            {renderContent()}
            {icon && <div className="note-field-layout__icon">{renderIcon()}</div>}
        </div>
    );
};

export default NoteFieldLayout;
